import { useTranslations } from "next-intl";
import { SCard } from "@/components/Card/SCard";
import { Spacing } from "@/components/Spacing/Spacing";
import { AuthLayout } from "./AuthLayout";
import ResetPasswordForm from "./reset-password/ResetPasswordForm";

export function ResetPasswordPage() {
  const t = useTranslations("resetPassword");
  return (
    <AuthLayout>
      <SCard
        header={t("resetPasswordTitle")}
        outline="outline-quaternary"
        shadow="shadow-xl"
      >
        <Spacing height="h-6" />
        <p className="body-1-regular">{t("resetPasswordDescription")}</p>
        <Spacing height="h-6" />
        <ResetPasswordForm />
      </SCard>
    </AuthLayout>
  );
}
